/**
 * /api/decisions — Claude decision audit trail.
 *
 * Read-only projection of the `audit_log` table. The dashboard's Decisions
 * page uses this as a transparent log of every gate decision (haiku) and
 * full compliance review (sonnet) that ran against a hedge pair.
 */

import { z } from "zod";

/** Single audit_log row, projected to the fields the dashboard needs. */
export const DecisionRowZ = z.object({
  id: z.number().int(),
  pair_id: z.string(),
  /** From the joined pairs row — null if the pair has been deleted. */
  symbol: z.string().nullable(),
  account_id: z.string().nullable(),
  firm_id: z.string(),
  tier: z.enum(["haiku", "sonnet"]),
  /** Claude's chosen action (e.g. "execute", "hold", "block", "continue", "alert"). */
  claude_action: z.string(),
  compliance_status: z.string().nullable(),
  violation_detail: z.string().nullable(),
  /** JSON-encoded array of rule-check identifiers; the page parses on render. */
  rules_checked: z.string().nullable(),
  reason: z.string(),
  /** 0..1 from Sonnet; null for Haiku gate calls. */
  confidence: z.number().nullable(),
  /** Whether the Worker actually executed this action against the broker. */
  executed: z.number().int(),
  cost_usd: z.number().nullable(),
  created_at: z.number().int(),
});
export type DecisionRow = z.infer<typeof DecisionRowZ>;

export const ListDecisionsResZ = z.object({
  decisions: z.array(DecisionRowZ),
});
export type ListDecisionsRes = z.infer<typeof ListDecisionsResZ>;
